import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface redeemData {
  products: Array<any>;
  coupons: Array<any>;
  history: Array<any>;
  setProducts: (products: any) => void;
  setCoupons: (coupons: couponProps) => void;
  setHistory: (history: any) => void;
}

interface couponProps {
  _id: string;
  balance: number;
  cost: number;
  couponCode: string;
  product: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}

const useRedeem = create<redeemData>()(
  persist(
    (set) => ({
      products: [],
      coupons: [],
      history: [],
      setCoupons: (coupons: couponProps) => {
        set((state) => ({
          ...state,
          coupons: [...state.coupons, coupons],
        }));
      },
      setProducts: (products: []) => {
        set((state) => ({
          ...state,
          products,
        }));
      },
      setHistory: (history: []) => {
        set((state) => ({
          ...state,
          history,
        }));
      },
    }),
    {
      name: 'redeem',
    },
  ),
);

export default useRedeem;
